import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { trackBrandLeadsBrandsPageHeaderSectionView } from "@faire/web-api--source/events/brandLeads/view/brandsPageHeaderSection";
import { trackR2BReferralsClicksOnSignUpToSellButtonClick } from "@faire/web-api--source/events/r2BReferrals/click/clicksOnSignUpToSellButton";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import styled from "styled-components";
var TopSectionBase = function() {
    useEffect(function() {
        trackBrandLeadsBrandsPageHeaderSectionView();
    }, []);
    return /*#__PURE__*/ _jsxs(Column, {
        style: {
            backgroundColor: Decorative.shade.yellow,
            width: "100%"
        },
        children: [
            /*#__PURE__*/ _jsx(HeaderContent, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "7x"
            }),
            /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                desktopAndAbove: /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                })
            })
        ]
    });
};
export var TopSection = observer(TopSectionBase);
var SignUpToSellButton = function() {
    return /*#__PURE__*/ _jsx(SignUpButton, {
        onClick: trackR2BReferralsClicksOnSignUpToSellButtonClick,
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "2tRPfG",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sign up to sell"
                }
            ]
        })
    });
};
var CTAButtons = function() {
    return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
        tabletAndBelow: /*#__PURE__*/ _jsx(SignUpToSellButton, {}),
        desktopAndAbove: /*#__PURE__*/ _jsx(Row, {
            children: /*#__PURE__*/ _jsx(SignUpToSellButton, {})
        })
    });
};
var TitleText = function() {
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "Vs8454",
        defaultMessage: [
            {
                type: 0,
                value: "Claim your offer to get one-on-one assistance setting up your shop"
            }
        ]
    });
};
var MobileTitle = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        align: "flex-start",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displaySSerifRegular",
                color: Core.text.inverse,
                children: /*#__PURE__*/ _jsx(TitleText, {})
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(CTAButtons, {})
        ]
    });
};
var BrandsDesktopTitle = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(DesktopTitle, {
                variant: "displayLSerifRegular",
                color: Core.text.inverse,
                align: "center",
                children: /*#__PURE__*/ _jsx(TitleText, {})
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(CTAButtons, {})
        ]
    });
};
var BrandsPageTitle = function() {
    return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
        tabletAndBelow: /*#__PURE__*/ _jsx(MobileTitle, {}),
        desktopAndAbove: /*#__PURE__*/ _jsx(BrandsDesktopTitle, {})
    });
};
var HeaderContentBase = function() {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(BrandsPageTitleWrapper, {
            children: /*#__PURE__*/ _jsx(BrandsPageTitle, {})
        })
    });
};
var HeaderContent = observer(HeaderContentBase);
var DesktopTitle = styled(Typography).withConfig({
    componentId: "sc-9801434a-0"
})([
    "max-width:780px;"
]);
var BrandsPageTitleWrapper = styled(Column).attrs({
    justify: {
        mobileAndAbove: "left",
        tabletAndAbove: "center"
    },
    align: {
        mobileAndAbove: "flex-start",
        tabletAndAbove: "center"
    }
}).withConfig({
    componentId: "sc-9801434a-1"
})([
    "width:100%;padding:",
    ";"
], getSpacing(0, "3x"));
styled(Button).attrs({
    variant: "secondary",
    target: "_blank"
}).withConfig({
    componentId: "sc-9801434a-2"
})([
    "width:max-content;color:",
    ";background-color:",
    ";",
    "{width:100%;justify-content:center;align-items:center;padding:0;}"
], Core.text.default, Core.surface.inverse, responsiveMediaQueries.mobile);
var SignUpButton = styled(Button).attrs({
    variant: "secondary",
    target: "_blank"
}).withConfig({
    componentId: "sc-9801434a-3"
})([
    "width:max-content;color:",
    ";background-color:transparent;border:1px solid ",
    ";",
    "{width:100%;justify-content:center;align-items:center;padding:0;}"
], Core.text.inverse, Core.border.muted, responsiveMediaQueries.mobile);
